import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Rosario'
}, {
  name: 'Laura',
  city: 'Córdoba'
}, {
  name: 'Florencia',
  city: 'Buenos Aires'
}, {
  name: 'Sofía',
  city: 'Mendoza'
}, {
  name: 'Luciana',
  city: 'La Plata'
}, {
  name: 'Carolina',
  city: 'Mar del Plata'
}, {
  name: 'Julieta',
  city: 'Tucumán'
}, {
  name: 'Agustina',
  city: 'Salta'
}, {
  name: 'Romina',
  city: 'Neuquén'
}, {
  name: 'Paula',
  city: 'Santa Fe'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setCurrentBuyer(randomBuyer);
      setTimeAgo(randomTime);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 3000);
    // Recurring timer
    const intervalTimer = setInterval(() => {
      showPopup();
    }, 12000); // Every 12 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-139">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 right-4 md:right-auto md:w-80 bg-white rounded-lg shadow-xl border border-slate-100 p-3 z-50 flex items-start gap-3" data-id="element-140">
          <div className="bg-green-100 p-1.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-141">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-142" />
          </div>
          <div data-id="element-143">
            <p className="text-sm font-medium text-slate-800 leading-tight" data-id="element-144">
              {currentBuyer.name} de {currentBuyer.city} acaba de comprar el Kit
              Consultorio Pro
            </p>
            <p className="text-xs text-slate-500 mt-1" data-id="element-145">
              hace {timeAgo} minuto{timeAgo !== 1 ? 's' : ''}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}